<div>
  <mode-layer-type-selector
    [series]="series"
    [renderModel]="renderModel"
    [encoding]="encoding"
    [markType]="markType"
    [automatic]="automatic"
    (optionsChanged)="onLayerOptionsChanged($event)"
    (markTypeChanged)="onMarkTypeChanged($event)"
  >
  </mode-layer-type-selector>
  <div class="field-list">
    <div
      class="mark-field {{ summary.channel }}"
      [class.first]="isFirst"
      *ngFor="let summary of channelSummarys; first as isFirst; trackBy: trackByChannelSummary"
      [ngSwitch]="summary.channel"
    >
      <ng-container *ngSwitchCase="'color'">
        <mode-color-channel-component
          [channelSummary]="summary"
          [encoding]="encoding"
          [model]="model"
          [view]="view"
          [renderModel]="renderModel"
          [chartService]="chartService"
          [chartType]="chartType"
          [series]="series"
          [queryToken]="queryToken"
          [queryRunToken]="queryRunToken"
          [vizToken]="vizToken"
          [fieldFormatMap]="fieldFormatMap"
          [fieldColorMap]="fieldColorMap"
          [currentColorPaletteToken]="currentColorPaletteToken"
          [format]="format"
          [isAutoOrManualRender]="isAutoOrManualRender"
          [binSizeToFieldMap]="binSizeToFieldMap"
        ></mode-color-channel-component>
      </ng-container>
      <ng-container *ngSwitchCase="'text'">
        <mode-text-channel-component
          [channelSummary]="summary"
          [encoding]="encoding"
          [model]="model"
          [view]="view"
          [renderModel]="renderModel"
          [chartService]="chartService"
          [chartType]="chartType"
          [series]="series"
          [queryToken]="queryToken"
          [queryRunToken]="queryRunToken"
          [vizToken]="vizToken"
          [fieldFormatMap]="fieldFormatMap"
          [format]="format"
          [binSizeToFieldMap]="binSizeToFieldMap"
        ></mode-text-channel-component>
      </ng-container>
      <ng-container *ngSwitchCase="'angle'">
        <mode-channel-component
          [channelSummary]="summary"
          [encoding]="encoding"
          [model]="model"
          [view]="view"
          [chartService]="chartService"
          [chartType]="chartType"
          [series]="series"
          [fieldFormatMap]="fieldFormatMap"
          [format]="format"
          [queryToken]="queryToken"
          [vizToken]="vizToken"
          [allowScalars]="false"
          [allowDiscrete]="false"
          [requiresContinuous]="true"
          [binSizeToFieldMap]="binSizeToFieldMap"
        >
        </mode-channel-component>
      </ng-container>
      <ng-container *ngSwitchCase="'baseline'">
        <mode-baseline-channel-component
          [channelSummary]="summary"
          [encoding]="encoding"
          [model]="model"
          [view]="view"
          [chartService]="chartService"
          [chartType]="chartType"
          [series]="series"
          [fieldFormatMap]="fieldFormatMap"
          [format]="format"
          [queryToken]="queryToken"
          [vizToken]="vizToken"
        >
        </mode-baseline-channel-component>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <mode-channel-component
          [channelSummary]="summary"
          [encoding]="encoding"
          [model]="model"
          [view]="view"
          [chartService]="chartService"
          [chartType]="chartType"
          [series]="series"
          [fieldFormatMap]="fieldFormatMap"
          [format]="format"
          [queryToken]="queryToken"
          [vizToken]="vizToken"
          [binSizeToFieldMap]="binSizeToFieldMap"
        >
        </mode-channel-component>
      </ng-container>
    </div>
  </div>
</div>
